module.exports = __webpack_public_path__ + "static/blog-8-44d24612ef34f277ac9669f2915b4a8b.png";